import React, { useState, useRef } from "react";
import {
  GoogleMap,
  Marker,
  Autocomplete,
  useJsApiLoader,
} from "@react-google-maps/api";

const GOOGLE_MAPS_KEY = "AIzaSyBxZBJZC4ABTmxiB2VUgNx2yMkUJ6s4u30";
const libraries = ["places"];
const mapContainerStyle = {
  width: "100%",
  height: "220px",
  borderRadius: "10px",
};

export default function StepOneLocationDetails({
  addressName,
  setAddressName,
  fullAddress,
  setFullAddress,
  lat,
  lng,
  setLat,
  setLng,
  note,
  setNote,
  existingImages,
  newImages,
  setNewImages,
  addressTypes,
  selectedTypeId,
  onTypeSelect,
  fields,
  fieldValues,
  onFieldChange,
  onNext,
  onCancel,
  saving,
}) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_KEY,
    libraries,
  });

  const [autocomplete, setAutocomplete] = useState(null);
  const [mapEditable, setMapEditable] = useState(false);
  const fileInputRef = useRef(null);

  const onPlaceChanged = () => {
    if (!autocomplete) return;
    const place = autocomplete.getPlace();
    if (place.geometry) {
      setLat(place.geometry.location.lat());
      setLng(place.geometry.location.lng());
      setFullAddress(place.formatted_address || place.name || fullAddress);
    }
  };

  const geocodeLatLng = (newLat, newLng) => {
    if (!window.google) return;
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode(
      { location: { lat: newLat, lng: newLng } },
      (results, status) => {
        if (status === "OK" && results[0]) {
          setFullAddress(results[0].formatted_address);
        }
      },
    );
  };

  const onMapClick = (e) => {
    const newLat = e.latLng.lat();
    const newLng = e.latLng.lng();
    setLat(newLat);
    setLng(newLng);
    geocodeLatLng(newLat, newLng);
  };

  const handleFilesSelected = (e) => {
    const files = Array.from(e.target.files || []);
    setNewImages((prev) => [...prev, ...files]);
    e.target.value = "";
  };

  const removeNewImage = (idx) => {
    setNewImages((prev) => prev.filter((_, i) => i !== idx));
  };

  return (
    <div className="row">
      <div className="col-lg-8">
        <div className="wizard-card p-4">
          <p className="fw-semibold fs-5 mb-1">تحديد الموقع</p>
          <p className="text-muted small mb-3">
            اختر الموقع على الخريطة أو ابحث عن عنوان
          </p>

          {isLoaded && (
            <>
              <Autocomplete
                onLoad={setAutocomplete}
                onPlaceChanged={onPlaceChanged}
              >
                <input
                  type="text"
                  className="form-control mb-3 rtl-input"
                  placeholder="ابحث عن عنوان أو مكان..."
                />
              </Autocomplete>

              <div className="mb-3">
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={{ lat, lng }}
                  zoom={16}
                  onClick={mapEditable ? onMapClick : undefined}
                >
                  <Marker position={{ lat, lng }} />
                </GoogleMap>
              </div>
            </>
          )}

          <div className="d-flex justify-content-between align-items-start mb-3">
            <div style={{ width: "85%" }}>
              <label className="fw-semibold small">العنوان المحدد</label>
              <input
                type="text"
                className="form-control rtl-input mt-1"
                value={fullAddress}
                onChange={(e) => setFullAddress(e.target.value)}
                readOnly={!mapEditable}
              />
            </div>
            <button
              type="button"
              className="btn btn-link wizard-link-btn mt-4"
              onClick={() => setMapEditable((v) => !v)}
            >
              {mapEditable ? "تم" : "تغيير الموقع"}
            </button>
          </div>

          <div className="mb-3">
            <label className="fw-semibold small">اسم العنوان</label>
            <input
              type="text"
              className="form-control rtl-input mt-1"
              value={addressName}
              onChange={(e) => setAddressName(e.target.value)}
              placeholder="مثال: جراج الكومباوند"
            />
          </div>

          <div className="mb-3">
            <label className="fw-semibold small d-block mb-2">نوع المكان</label>
            <div className="wizard-types-grid">
              {addressTypes.map((t) => (
                <div
                  key={t.id}
                  className={`wizard-type-chip cursor ${
                    selectedTypeId === t.id ? "selected" : ""
                  }`}
                  onClick={() => onTypeSelect(t.id)}
                >
                  <img
                    src={`https://estbn.com/EstbnNew/public${t.icon_url}`}
                    alt=""
                    style={{ width: "22px", height: "22px" }}
                  />
                  <span>{t.label}</span>
                </div>
              ))}
            </div>
          </div>

          {fields.length > 0 && (
            <div className="d-flex flex-wrap mb-3" style={{ gap: "12px" }}>
              {fields.map((f) => (
                <div key={f.id} style={{ flexBasis: f.field_width || "100%" }}>
                  <label className="fw-semibold small">
                    {f.label}{" "}
                    {f.is_required && <span className="text-danger">*</span>}
                  </label>
                  {f.input_type === "select" ? (
                    <select
                      className="form-select mt-1 rtl-input"
                      value={fieldValues[f.key] || ""}
                      onChange={(e) => onFieldChange(f.key, e.target.value)}
                    >
                      <option value="">اختر...</option>
                      {f.options.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      className="form-control mt-1 rtl-input"
                      placeholder={f.placeholder || ""}
                      value={fieldValues[f.key] || ""}
                      onChange={(e) => onFieldChange(f.key, e.target.value)}
                    />
                  )}
                </div>
              ))}
            </div>
          )}

          <div className="mb-3">
            <label className="fw-semibold small">ملاحظات إضافية</label>
            <textarea
              className="form-control mt-1 rtl-input"
              rows="3"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="أضف تفاصيل تساعد فريق الخدمة في الوصول إليك"
            ></textarea>
          </div>
        </div>
      </div>

      <div className="col-lg-4">
        <div className="wizard-tip-box mb-3">
          <p className="fw-semibold mb-1">
            <i className="fa-regular fa-lightbulb me-2"></i>نصائح
          </p>
          <p className="small mb-0 text-muted">
            كل ما كانت تفاصيل الموقع دقيقة، كل ما كانت الخدمة أسرع وأسهل.
          </p>
        </div>

        <div className="wizard-example-box mb-3">
          <p className="fw-semibold mb-1">مثال</p>
          <p className="small mb-0 text-muted">
            جراج مبني 5 - الدور الثاني تحت الأرض - موقف رقم 12 - بجانب المصعد.
          </p>
        </div>

        <div className="wizard-card p-3">
          <p className="fw-semibold small mb-2">صورة من الموقع (اختياري)</p>
          <div className="d-flex flex-wrap gap-2 mb-2">
            {existingImages.map((img) => (
              <img
                key={img.id}
                src={img.image_url}
                alt=""
                className="wizard-img-thumb"
              />
            ))}
            {newImages.map((file, idx) => (
              <div key={idx} className="position-relative">
                <img
                  src={URL.createObjectURL(file)}
                  alt=""
                  className="wizard-img-thumb"
                />
                <span
                  className="wizard-img-remove"
                  onClick={() => removeNewImage(idx)}
                >
                  ×
                </span>
              </div>
            ))}
          </div>
          <div
            className="wizard-upload-box cursor"
            onClick={() => fileInputRef.current?.click()}
          >
            <i className="fa-solid fa-arrow-up fs-4 mb-1"></i>
            <span className="small">أضف صورة</span>
            <span className="small text-muted">JPG/PNG حتى 5 ميجابايت</span>
          </div>
          <input
            type="file"
            ref={fileInputRef}
            accept="image/png, image/jpeg"
            multiple
            hidden
            onChange={handleFilesSelected}
          />
        </div>
      </div>

      <div className="col-12 d-flex justify-content-between mt-4">
        <button className="btn wizard-btn-outline" onClick={onCancel}>
          إلغاء
        </button>
        <button
          className="btn wizard-btn-dark"
          onClick={onNext}
          disabled={saving}
        >
        <i className="fa-solid fa-arrow-right me-1"></i>
          {saving ? "جاري الحفظ ... " : "التالي : تفاصيل المكان"}{" "}
        </button>
      </div>
    </div>
  );
}
